<script setup lang="ts">
import { watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useLocaleStore } from '@/stores/locale.store'

useDynamicColors()

const { locale } = useI18n()
const localeStore = useLocaleStore()

watch(locale, lang => localeStore.setLanguage(lang), { immediate: true })
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
    <ToastContainer />
  </NuxtLayout>
</template>
